import React from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ListItemIcon,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import i18next from "i18next";

const DomainGuidelinesSection = () => {
  const isArabic = i18next.language === "ar";
  return (
    <Box sx={{ width: "100%", marginTop: "5%" }}>
      <Typography
        sx={{
          fontFamily: "Tajawal-Regular",
          fontSize: "26px",
          color: "#575452",
          fontWeight: 700,
        }}
      >
        {i18next.t("DOMAIN_SELECTION_SECTION_HEADING_1")}
      </Typography>

      <Typography
        sx={{
          fontFamily: "Tajawal-Regular",
          fontSize: "22px",
          color: "#575452",
        }}
      >
        {i18next.t("DOMAIN_SELECTION_SECTION_HEADING_2")}:
      </Typography>

      <List>
        {[
          "DOMAIN_SELECTION_SECTION_RULES_1",
          "DOMAIN_SELECTION_SECTION_RULES_2",
          "DOMAIN_SELECTION_SECTION_RULES_3",
        ].map((text, index) => (
          <ListItem
            key={index}
            sx={{
              flexDirection: isArabic ? "row-reverse" : "row",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            <ListItemIcon
              sx={{
                display: isArabic ? "none" : "flex", // hide bullet point if Arabic
                minWidth: 0,
                mt: "6px",
                ...(isArabic
                  ? { marginLeft: "10px" }
                  : { marginRight: "10px" }),
              }}
            >
              <FiberManualRecordIcon
                sx={{ fontSize: "8px", color: "#575452" }}
              />
            </ListItemIcon>
            <ListItemText
              primary={i18next.t(text)}
              primaryTypographyProps={{
                sx: {
                  textAlign: isArabic ? "right" : "left",
                  fontWeight: isArabic ? 700 : 400,
                },
              }}
            />
          </ListItem>
        ))}
      </List>

      <Typography
        sx={{
          fontFamily: "Tajawal-Regular",
          fontSize: "22px",
          color: "#575452",
        }}
      >
        {i18next.t("DOMAIN_SELECTION_SECTION_HEADING_3")}:
      </Typography>

      <TableContainer
        component={Paper}
        sx={{ maxWidth: "90%", marginTop: "2.5%" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ maxWidth: 50 }}>
                <strong>
                  {i18next.t("DOMAIN_SELECTION_SECTION_TABLE_HEADING_1")}
                </strong>
              </TableCell>
              <TableCell sx={{ maxWidth: 50 }}>
                <strong>
                  {" "}
                  {i18next.t("DOMAIN_SELECTION_SECTION_TABLE_HEADING_2")} Points
                  to / IP address
                </strong>
              </TableCell>
              <TableCell sx={{ maxWidth: 50 }}>
                <strong>
                  {" "}
                  {i18next.t("DOMAIN_SELECTION_SECTION_TABLE_HEADING_3")} TTL
                  (Sec)
                </strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              fontFamily: "Tajawal-Regular",
              fontSize: "20px",
              color: "#575452",
            }}
          >
            <TableRow>
              <TableCell sx={{ maxWidth: 50 }}>@</TableCell>
              <TableCell align="left" sx={{ maxWidth: 50 }}>
                34.71.150.141
              </TableCell>
              <TableCell sx={{ maxWidth: 50 }}>
                {i18next.t("Automatic")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ maxWidth: 50 }}>www</TableCell>
              <TableCell align="left" sx={{ maxWidth: 50 }}>
                34.71.150.141
              </TableCell>
              <TableCell sx={{ maxWidth: 50 }}>
                {i18next.t("Automatic")}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DomainGuidelinesSection;
